<div class="paginacion">

  <button
    (click)="cambiarPagina(paginaActual - 1)"
    [disabled]="paginaActual === 1"
  >
    ←
  </button>

  <span>
    Página {{ paginaActual }} de {{ totalPaginas }}
  </span>

  <button
    (click)="cambiarPagina(paginaActual + 1)"
    [disabled]="paginaActual === totalPaginas"
  >
    →
  </button>

</div>
